import React from 'react'

const ActionButtonStyles = '[&>.button]:button-action';

export const AgTechVerticalPopUpMenu = (props: { children: React.ReactNode }) => {
    return (
        <div className="row-based min-w-[160px] container">
            {props.children}
        </div>
    );
}

export type AgTechVerticalPopUpMenuSectionProps = {
    header?: string
}

export const AgTechVerticalPopUpMenuSection = (props: React.PropsWithChildren<AgTechVerticalPopUpMenuSectionProps>) => {
    return (
        <div className={`border-b p-3 pb-1 row-based container ${ActionButtonStyles}`}>
            {props.header && <h1 className="pl-[2px] pb-2 text-sm font-semibold">{props.header}</h1>}
            {props.children}
        </div>
    )
}